import { environment } from '@environment';

function getUploadsStorageFolder() {
    if (environment.uploadsStorageFolder) {
        return environment.uploadsStorageFolder;
    }

    return environment.name === 'production' ? 'live' : 'qa';
}

function appendQuery(url: string, query: string) {
    if (!query) {
        return url;
    }

    return `${url}${query.startsWith('?') ? query : `?${query}`}`;
}

export function getClientLogoUrl(clientId?: number | null, cacheKey?: number | string) {
    if (!clientId) {
        return '';
    }

    const folder = getUploadsStorageFolder();
    const baseUrl = `${environment.azureNetraMediaUrl}/${environment.azureContainerName}/${folder}/clients/${clientId}/logo`;
    const urlWithSas = appendQuery(baseUrl, environment.fileStorageSas ?? '');

    if (!cacheKey) {
        return urlWithSas;
    }

    return `${urlWithSas}${urlWithSas.includes('?') ? '&' : '?'}v=${encodeURIComponent(`${cacheKey}`)}`;
}
